export const DsButtonDefaultProps = {
    variant: 'contained',
    size: 'small',
    color: 'primary',
    disableElevation: true
};
